import script from "./NewConfirm.vue?vue&type=script&setup=true&lang=js"
export * from "./NewConfirm.vue?vue&type=script&setup=true&lang=js"

import "./NewConfirm.vue?vue&type=style&index=0&id=09749f8a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-09749f8a"]])

export default __exports__